import { CourseAdminCard } from '@/components/shared/CourseAdminCard';
import {
  CardDragglableProps,
  CardStaticProps,
} from '@/components/shared/CourseAdminCard/types';
import Lesson from '@/models/Lesson';
import LessonAddQuestionsButton from './LessonAddQuestionsButton';
import { usePedWorkspaceStatus } from '@/data/context/PedWorkspaceContext';

type LessonCardProps = {
  lesson: Lesson;
  onEdit?: (lessonId: number) => void;
  onDelete?: (lessonId: number) => void;
  onAddQuestions?: (lessonId: number) => void;
  showAddQuestions?: boolean;
  className?: string;
} & (CardStaticProps | CardDragglableProps);

export default function LessonCard({
  lesson,
  onEdit,
  showAddQuestions,
  onDelete,
  onAddQuestions,
  ...cardProps
}: LessonCardProps) {
  const { isLimitedEdition } = usePedWorkspaceStatus();
  return (
    <CourseAdminCard {...cardProps}>
      <CourseAdminCard.Header>
        <CourseAdminCard.Leading>
          <CourseAdminCard.Order value={lesson.order} />
          <CourseAdminCard.TitleBlock>
            <CourseAdminCard.Title>{lesson.name}</CourseAdminCard.Title>
            {lesson.description && (
              <CourseAdminCard.Description>
                {lesson.description}
              </CourseAdminCard.Description>
            )}
          </CourseAdminCard.TitleBlock>
        </CourseAdminCard.Leading>
        <CourseAdminCard.Actions>
          {showAddQuestions && (
            <LessonAddQuestionsButton
              activities={lesson.activities}
              onAddQuestions={
                onAddQuestions ? () => onAddQuestions(lesson.id) : undefined
              }
            />
          )}
          {onEdit && (
            <CourseAdminCard.EditButton onClick={() => onEdit(lesson.id)} />
          )}
          {onDelete && (
            <CourseAdminCard.MoreActions>
              <CourseAdminCard.MoreActions.Delete
                onClick={() => onDelete(lesson.id)}
                disabled={isLimitedEdition}
              />
            </CourseAdminCard.MoreActions>
          )}
        </CourseAdminCard.Actions>
      </CourseAdminCard.Header>
    </CourseAdminCard>
  );
}
